/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Row, Col } from "react-awesome-styled-grid";
import {
  Box,
  FlexContainer,
  Switch,
  SwitchProps,
  Text,
  theme,
} from "@nordcloud/gnui";

type Props = SwitchProps & {
  label: string;
  description: string;
  onChange: (event: React.MouseEvent<HTMLDivElement>) => void;
  children?: React.ReactNode;
};

export function BoxWithSwitch({
  label,
  description,
  onChange,
  children = null,
  ...props
}: Props) {
  return (
    <Box boxStyle="lightGrey">
      <Row>
        <Col sm={1}>
          <FlexContainer justifyContent="center" alignItems="center">
            <Switch {...props} onChange={onChange} />
          </FlexContainer>
        </Col>
        <Col>
          <FlexContainer
            style={{ cursor: "pointer", width: "26rem" }}
            alignItems="flex-start"
            direction="column"
            onClick={onChange}
          >
            <Text tag="div" size="md">
              {label}
            </Text>
            <Text
              tag="div"
              size="sm"
              weight="regular"
              color={theme.color.text.text02}
            >
              {description}
            </Text>
          </FlexContainer>
          {children}
        </Col>
      </Row>
    </Box>
  );
}
